import { render, staticRenderFns } from "./InfrastructureBilling.vue?vue&type=template&id=493fc4ec&"
import script from "./InfrastructureBilling.vue?vue&type=script&lang=js&"
export * from "./InfrastructureBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports